import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { Link } from '../../../../../../../CommonComponents/OPL/Link/Link';
import { logo } from '../../FirmLogo.meta';

interface Props {
  customFirmUrl: string;
}

export const LogoInfo: React.FC<Props> = ({ customFirmUrl }) => {
  return (
    <>
      <Box as="ul" mt="8" pl="24">
        <Text as="li" color="inherit">
          Horizontal format preferred
        </Text>
        <Text as="li" color="inherit">
          Format in transparent .png preferred, but .jpg and .jpeg are also acceptable
        </Text>
        <Text as="li" color="inherit">
          {logo.formattedMaxFileSize} file size maximum
        </Text>
      </Box>

      <Text color="inherit" mt="24">
        Your logo will be visible in your custom login page{' '}
        <Link href={`//${customFirmUrl}`}>{customFirmUrl}</Link>, the client portal, PDF report and
        in Presentation mode.
      </Text>
    </>
  );
};
